/**
 * Keeps the cart icon on the add to cart button.
 *
 * When the variant changes, the theme replaces the button's contents with the new label as plain HTML, which drops the
 * icon and the wrapper that laid it out beside the text. This listens for the same event, and since it registers after
 * the theme's own listener, it runs once that rewrite is done and rebuilds the button's contents from scratch: the
 * icon and the label back inside the wrapper the theme styles.
 *
 * A disabled button ("Sold out") keeps its text alone, the way it renders on a first load.
 */
(function () {
  const ICON_SELECTOR = '.icon-cart-add';
  const WRAPPER_CLASS = 'text-with-icon justify-center';

  function setup(buyButtons) {
    if (buyButtons.dataset.iconKeeper === 'true') return;

    const button = buyButtons.querySelector('button[type="submit"]');
    const icon = button?.querySelector(ICON_SELECTOR);
    const form = document.forms[buyButtons.getAttribute('form')];
    if (!icon || !form) return;

    buyButtons.dataset.iconKeeper = 'true';
    const iconTemplate = icon.cloneNode(true);

    form.addEventListener('variant:change', () => {
      const label = (button.textContent || '').trim();
      if (!label) return;

      if (button.disabled) {
        button.textContent = label;
        return;
      }

      const wrapper = document.createElement('div');
      wrapper.className = WRAPPER_CLASS;
      wrapper.appendChild(iconTemplate.cloneNode(true));
      wrapper.appendChild(document.createTextNode(label));

      button.replaceChildren(wrapper);
    });
  }

  function init() {
    document.querySelectorAll('buy-buttons').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Sections re-render in the theme editor, so newly added buy buttons are picked up too. */
  document.addEventListener('shopify:section:load', init);
})();
